module.exports = __webpack_public_path__ + "static/media/DSC03532.6d1880e4.JPG";